export default __webpack_public_path__ + "assets/playlistbuttonssnapshot-e231e6c58d808be016ffd2348e5ab42b.png";